import React from "react";
import { useState, useEffect} from "react";
import { fetchConToken } from "helpers/fetch";


import { 
  AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer
} from 'recharts';
import PropTypes from 'prop-types';
//import CustomizedAxisTick from './CustomizedAxisTick';
import moment from "moment";
import Swal from 'sweetalert2';

import "./customAreaChart.css"


export default function CustomAreaChart(props) {
  
  //console.log("Updating Component");
  //console.log(props);
  const { start, stop, query, sensors, fillcolor, strokecolor, units, factor } = props;

  console.log("start in CAC:" + start);
  console.log("sensors in CAC:" + sensors);
  console.log("query in CAC:" + query);
  //console.log(measure);

  //let [data, setData] = useState([]);
  let [data3, setData3] = useState([]);

  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      try {
        const resp = await fetchConToken( `data?start=`+start+`&stop=`+stop+`&query=`+query+ `&sensors=`+sensors )
        const body = await resp.json();
        
        console.log("effect in CAC historicos:" + sensors);
        
        if( body.ok ) {
            if(mounted) {
              //setData(body.data)

              let modifiedDate = body.data.map((entry)=>{
                //console.log("Data en CAC: ", "time:" + entry.time, "timeFormated:" + moment(entry.time).format('ha'),  "value: "+ entry.value/factor );
                
                return {time: entry.time, timeFormated: ''+moment(entry.time).format('D/MM/YY(ha)'),  value: entry.value/factor }
              })
              //console.log(data);
              setData3(modifiedDate);

            }
        }else{
          Swal.fire('Error colectando metricas 0x0CC1', "No está autorizado", 'error');
        }
      } catch (error) {
        Swal.fire('Error colectando metricas 0x0CC2', "No existen metricas", 'error');
      }
    }
    fetchData();
    return () => mounted = false;
  }, [sensors, start, stop])
  
 /*  const grouped = data.reduce(function (r, a) {
      r[a.dev_name] = r[a.dev_name] || [];
      r[a.dev_name].push(a);
      return r;
  }, Object.create(null));

  console.log("Grouped:", grouped);
 */

 /*  const groupBy = (array) => {
    return array.reduce((result, currentValue) => {
      (result[currentValue.dev_name] = result[currentValue.dev_name] || []).push(
        currentValue
      );
      console.log(result);
      return result;
    }, {});
  };
  
  const dataGroupedByName = groupBy(data); */
  // console.log("grouped ",dataGroupedByName);
  // console.log(dataGroupedByName)
  //console.log(data);
  //console.log('LOCALE ' + moment.locale() + " offset: " + moment().utcOffset() );

  //const formatXAxis = (tickItem) => { // do something to format tick label 
    //console.log(tickItem); 
    //moment(tickItem).format('MMM Do YY')
  //}
  
 /*  const CustomizedAxisTick = ({ x, y, payload }) => {
    
    const dateTip = moment(payload.value);
    const localDateTip = dateTip.format("h:MM a");
      //.slice(0, 6);
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={23} y={0} dy={14} fontSize="0.90em"  textAnchor="end" fill="#363636">
         {localDateTip}
        </text>
       </g>
     );
  } */



  return (
    
      <div style={{ width: '100%', height: '100%' }}>
        <ResponsiveContainer key={`rcs_${query}+${sensors}`} >
          <AreaChart
            data={data3}
            margin={{
              top: 10,
              right: 10,
              left: -20,
              bottom: 0,
            }}
            key={`rcs_${query}+${sensors}`}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="timeFormated"   interval="preserveEnd" minTickGap={50} />
            <YAxis type="number" domain={['auto', 'auto']}/>
            <Tooltip 
              wrapperStyle={{ backgroundColor: "beige" }}
              labelStyle={{ color: "darkblue" }}
              itemStyle={{ color: "ButtonText" }}
              formatter={function(value) {
                return [`${Number(value).toFixed(2)} ` + units ];
              }}
              /* labelFormatter={function(value) {
                const dateTip = moment(value)
                .format("LT");
                return `${dateTip}`;
              }} */
            />
            <Area type="monotone" dataKey="value" stroke={strokecolor} fill={fillcolor} />



          </AreaChart>
        </ResponsiveContainer>
      </div>
    
  );

};




CustomAreaChart.propTypes = {
  start: PropTypes.string.isRequired,
  measure: PropTypes.string.isRequired,
  x : PropTypes.any,
  y : PropTypes.any,
  stroke : PropTypes.any,
  payload : PropTypes.any,
  active : PropTypes.any,
  label : PropTypes.any,
}

CustomAreaChart.defaultProps = {
  start: "-1h",
  stop: "now()",
  measure: "device_frmpayload_data_voltage",
  deveui: "65d993f557cacc29",
  fillcolor: '#33B11E',
  strokecolor: "#2B9E18",
}